module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page page-product",
    style: ({
      'backgroundImage': (!_vm.$root.isMobile) ? 'url(' + _vm.bg + ')' : ''
    })
  }, [_c('productSlider', {
    attrs: {
      "bg": _vm.bg
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-df80e262","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/product/productBase.vue
// module id = 650
// module chunks = 1